import React from 'react'
import type { BetSlipItem, FobBetReceiptResponse } from '@mobi/betslip/types'
import { getHostHelpers } from '@mobi/betslip/helpers/hostHelpers'
import { ShareButton } from '@mobi/betslip/Components/Common/BetCard/Components/FooterButtons/FooterButtons'
import { useSelector } from 'react-redux'
import { selectShouldAllowPendingBetShare } from '@mobi/betslip/Store/Config/selectors'
import { BetSlipContext } from '@mobi/betslip/context'

export const ShareMyBet: React.FC<{
  items: BetSlipItem[]
  isBetPlaced: boolean
  multiReceipt?: FobBetReceiptResponse
  ticketSequence?: number
}> = ({ items, isBetPlaced, multiReceipt, ticketSequence }) => {
  const hostHelpers = getHostHelpers()

  const toastEmitter = React.useContext(BetSlipContext)?.toastEmitter
  const shouldAllowPendingBetShare = useSelector(selectShouldAllowPendingBetShare)

  if (!hostHelpers.canShareBet() || (!shouldAllowPendingBetShare && !isBetPlaced)) {
    return null
  }

  const handleOpen = () =>
    hostHelpers.handleShareBet({ items, isBetPlaced, multiReceipt, ticketSequence, toastEmitter, betSource: 'share-bet' })

  return <ShareButton onClick={handleOpen} />
}
